import React, { useEffect, useState } from 'react';
import { HexColorPicker, HexColorInput } from 'react-colorful';
// import OutsideClickHandler from 'react-outside-click-handler';
import cn from 'clsx';
import themeVariables from '~/shared/themeVariables';
// import Config from '~/config';

const defaultColors = [
  // '#ffc7f0',
  // '#ed1d25',
  // '#f7931e',
  // '#fcee20',
  // '#039145',
  // '#8cdc2e',
  // '#48dbeb',
  // '#0000d6',
  // '#ffffff',
  // '#b3b3b3',
  // '#000000',
  // '#603813',
  // '#6640b8',
  // '#dbc57f',
  '#FFFFFF',
  '#000000',
  '#E72525',
  '#F48700',
  '#E78C33',
  '#F1F059',
  '#B5E14C',
  '#5ED13F',
  '#5AC79E',
  '#65DDDE',
  '#55ACEE',
  '#EA06B1',
];
const ColorPicker = ({ style, value, onChange, t }) => {
  const [selectedColor, setSelectedColor] = useState('');
  const [pickedColor, setPickedColor] = useState('');

  useEffect(() => {
    const newValue = `#${value.toUpperCase()}`;
    if (value && value !== 'all') {
      if (defaultColors.includes(newValue)) {
        setSelectedColor(newValue);
      } else {
        setPickedColor(newValue);
      }
    } else {
      setSelectedColor('');
      setPickedColor('');
    }
  }, [value]);
  // const [pickingColor, setPickingColor] = useState('');

  // useEffect(() => {
  //   if (value && value !== 'all') {
  //     if (defaultColors.includes('#' + value)) {
  //       setSelectedColor('#' + value);
  //     } else {
  //       setSelectedColor(-1);
  //       setPickedColor('#' + value);
  //     }
  //     setPickingColor(value);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (value === 'all') {
  //     setSelectedColor(null);
  //   }
  // }, [value]);

  // // const handleSelectColorPicker = () => {
  // //   if (pickedColor) {
  // //     setSelectedColor(-1);
  // //   }
  // //   setIsPickerVisible(true);
  // // };

  // useEffect(() => {
  //   console.log('changee', selectedColor, pickedColor);
  //   if (selectedColor === -1 || !selectedColor) {
  //     if (pickedColor) {
  //       onChange(pickedColor.toLowerCase().substring(1));
  //     }
  //   } else if (selectedColor) {
  //     console.log('CHANGE--------------->', selectedColor);
  //     onChange(selectedColor.toLowerCase().substring(1));
  //   }
  // }, [selectedColor, pickedColor]);

  const onPickColor = () => {
    if (pickedColor) {
      onChange(pickedColor.toLowerCase().substring(1));
      setSelectedColor('');
    }
  };

  const onSelectColor = (color) => {
    if (color === selectedColor) {
      onChange('all');
      setSelectedColor('');
    } else {
      onChange(color.toLowerCase().substring(1));
      setSelectedColor(color);
    }
    setPickedColor('');
  };

  const handleChangeColor = (value) => {
    setPickedColor(value);
  };

  return (
    <>
      <div className="color-picker" style={style}>
        {defaultColors.map((color) => (
          <div
            key={color}
            className={cn(
              'color-item',
              {
                selected: color === selectedColor,
              },
              color.replace('#', ''),
            )}
            style={{ background: color }}
            onClick={() => onSelectColor(color)}
          >
            {color === selectedColor && (
              <span
                className={cn({
                  'close-symbol-white': selectedColor === '#000000',
                })}
              >
                x
              </span>
            )}
          </div>
        ))}
        {/* <div className={cn('color-item', { selected: selectedColor === -1 })}>
          {pickedColor ? (
            <div
              className="pick-color-checked"
              style={{ background: pickedColor, width: '100%', height: '100%' }}
              onClick={handleSelectColorPicker}
            >
              <span>x</span>
            </div>
          ) : (
            <img
              onClick={handleSelectColorPicker}
              className="image-color-picker"
              src={`${Config.staticPrefix}/static/images/color-picker.png`}
              alt={'logo color picker'}
            />
          )}
        </div> */}
      </div>
      {/* {isPickerVisible && (
        <OutsideClickHandler
          className="color-picker-wrapper"
          onOutsideClick={(evt) => {
            evt.stopPropagation();
            setIsPickerVisible(false);
          }}
        > */}
      <div className="color-picker-wrapper">
        <h3>{t('color_pick_custom_color')}</h3>
        <div className="hex-color-picker">
          <HexColorPicker
            color={pickedColor || '#FFFFFF'}
            onChange={handleChangeColor}
          />
        </div>
        <div className="hex-input-container">
          <span className="hex-input-title">
            {t('color_hex_code_input_title')}
          </span>
          <div className="hex-show-detail">
            <span className="hex-show-color"></span>
            <span className="hex-color-symbol">#</span>
            <HexColorInput
              className="hex-input-wrapper"
              color={pickedColor || '#FFFFFF'}
              onChange={handleChangeColor}
            />
          </div>
        </div>
        <div className="color-picker-action">
          <button onClick={onPickColor}>{t('apply')}</button>
        </div>
      </div>
      {/* </OutsideClickHandler>
      )} */}
      <style jsx>
        {`
          .hex-color-picker {
            width: 100%;
          }
          .color-picker-wrapper h3 {
            font-weight: 700;
            font-size: 16px;
            line-height: 28px;
            color: #000000;
          }
          .color-picker {
            width: 100%;
            display: grid;
            grid-template-columns: auto auto auto auto auto auto;
          }
          .hex-input-title {
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            color: #000000;
          }
          .hex-input-container {
            margin-top: 10px;
          }
          .hex-show-detail {
            display: flex;
            align-items: center;
            border-bottom: 2px solid ${themeVariables.color.primary};
            padding: 4px 0;
          }
          .hex-show-color {
            content: '';
            width: 28px;
            height: 28px;
            border: 1px solid #d1d1d1;
            background-color: ${pickedColor ? pickedColor : '#FFFFFF'};
            border-radius: 9999px;
          }
          .hex-color-symbol {
            font-size: 16px;
            position: relative;
            right: -15px;
          }
          .pick-color-checked {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 9999px;
          }
          .color-picker-action {
            display: flex;
            justify-content: space-between;
            margin-top: 16px;
          }
          .color-picker-action button {
            left: 37px;
            top: 12px;
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            padding: 12px 24px;
            border: 1px solid #d1d1d1;
            box-sizing: border-box;
            border-radius: 40px;
            width: 100%;
            height: 40px;
            background: #ffffff;
          }
          .color-picker-action button:hover {
            background: #f8f9fa;
          }
          .color-item {
            position: relative;
            width: 24px;
            height: 24px;
            margin: 4px;
            cursor: pointer;
            outline: none;
            padding: 0;
            border-radius: 9999px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .color-item:hover {
            opacity: 0.8;
          }
          .close-symbol-white {
            color: #ffffff;
          }
          .color-item.selected {
            // border: 2px solid ${themeVariables.color.primary};
          }
          .color-item.FFFFFF {
            border: 2px solid #c4c4c4;
          }
          .image-color-picker {
            max-width: 100%;
            max-height: 100%;
            position: absolute;
            border-radius: 9999px;
          }
          @media (max-width: 500px) {
            .color-picker {
              width: 100%;
              grid-template-columns: auto auto auto auto auto auto;
              grid-gap: 16px;
            }
          }
        `}
      </style>
      <style jsx global>
        {`
          .color-picker-wrapper {
            right: 24px;
            background: #fff;
            padding: 10px;
            display: inline-block;
            width: 100%;
          }

          .color-picker-wrapper .react-colorful {
            width: 100%;
            height: 160px;
            border-radius: 4px;
          }

          .color-picker-wrapper .react-colorful__hue {
            height: 16px;
            width: 100%;
            border-radius: 40px;
            margin-top: 10px;
          }

          .color-picker-wrapper .react-colorful__hue-pointer,
          .color-picker-wrapper .react-colorful__pointer {
            width: 20px;
            height: 20px;
            border-radius: 9999px;
          }

          .hex-input-wrapper {
            display: block;
            box-sizing: border-box;
            width: 90px;
            margin: 8px 0;
            border: none;
            outline: none;
            text-transform: uppercase;
            text-align: center;
            font-weight: 500;
            font-size: 16px;
            line-height: 28px;
          }
        `}
      </style>
    </>
  );
};

export default ColorPicker;
